export const siteSettings = {
  name: "Equity Market Hub",
  link: "https://equitymarkethub.net",
  email: "support@equitymarkethub.net",
  appLink: "https://app.equitymarkethub.net",
};
